<section id="faq" class="section faq-section">
  <div class="container">
    <div class="faq-container">
      <div class="faq-header">
        <h2 class="section-title" style="text-align: left;">Frequently Asked Questions</h2>
        <p class="section-subtitle" style="text-align: left; margin-left: 0;">Find answers to common questions about our KOTHA IP Telephony service.</p>
        <a href="#contact" class="btn btn-outline">Still have questions?</a>
      </div>

      <div class="faq-right">

        <!-- Loading State -->
        @if (isLoading) {
        <div class="faq-loading">
          <div class="faq-skeleton-tabs">
            @for (i of [1,2,3,4]; track $index) {
            <div class="faq-skeleton faq-skeleton-tab"></div>
            }
          </div>
          @for (i of [1,2,3]; track $index) {
          <div class="faq-skeleton faq-skeleton-item"></div>
          }
        </div>
        }

        <!-- Error State -->
        @if (!isLoading && hasError) {
        <div class="faq-error">
          <p>Unable to load FAQs. Please try again later.</p>
        </div>
        }

        <!-- Loaded Content -->
        @if (!isLoading && !hasError) {

          <!-- No data -->
          @if (categories.length === 0) {
          <div class="faq-empty">
            <p>No FAQs available at the moment.</p>
          </div>
          }

          @if (categories.length > 0) {
            <!-- Category Tabs -->
            <div class="faq-tabs">
              @for (cat of categories; track cat.id) {
              <button
                class="faq-tab"
                [class.faq-tab-active]="activeCategory?.id === cat.id"
                (click)="setCategory(cat)">
                {{ cat.name }}
              </button>
              }
            </div>

            <!-- FAQ List -->
            <div class="faq-list">
              @if (filteredFaqs.length === 0) {
              <div class="faq-empty">
                <p>No FAQs in this category yet.</p>
              </div>
              }

              @for (faq of filteredFaqs; track faq.id; let i = $index) {
              <div class="faq-item" [class.active]="faq.isOpen">
                <button class="faq-question" (click)="toggleFaq(i)">
                  <span>{{ faq.title }}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    @if (!faq.isOpen) {
                    <polyline points="6 9 12 15 18 9"></polyline>
                    }
                    @if (faq.isOpen) {
                    <polyline points="18 15 12 9 6 15"></polyline>
                    }
                  </svg>
                </button>
                <div class="faq-answer" [class.open]="faq.isOpen">
                  <div class="faq-answer-inner" [innerHTML]="faq.description">
                  </div>
                </div>
              </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</section>
